import { WHATSAPP_TEMPLATE_BLOCK_REASONS } from 'cpool-constants';

export function encodeUnknownVariablesBlockReason(unknownVariableNames: string[]): string {
    return `${WHATSAPP_TEMPLATE_BLOCK_REASONS.UNKNOWN_VARIABLES}:${unknownVariableNames.join(',')}`;
}

export function decodeUnknownVariablesBlockReason(raw: string): string[] | undefined {
    const prefix = `${WHATSAPP_TEMPLATE_BLOCK_REASONS.UNKNOWN_VARIABLES}:`;
    if (!raw.startsWith(prefix)) return undefined;
    return raw.slice(prefix.length).split(',');
}
